import { DateFormats } from '@/constants/dates';
import { TrashIcon } from '@/icons';
import { ISubscription } from '@/models/subscriptions.model';
import { Button } from '@/ui';
import { formatDate } from '@/utils';
import { ColumnsType } from 'antd/es/table';
import { TFunction } from 'react-i18next';

type TSubscriptionsTableColumns = {
  t: TFunction;
  onDelete: (item: ISubscription) => void;
  canManage: boolean;
  total?: number;
};

export const getSubscriptionsTableColumns = ({
  t,
  onDelete,
  canManage,
  total,
}: TSubscriptionsTableColumns): ColumnsType<ISubscription> => [
  {
    title: `${t('subscriptions_email_column')} (${total || 0})`,
    dataIndex: 'email',
    key: 'email',
    render: (_, record) => <a href={`mailto:${record?.email}`}>{record?.email}</a>,
  },
  {
    title: t('subscriptions_created_column'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (_, record) => <span>{formatDate(record?.created_at, DateFormats.EUROPEAN)}</span>,
  },

  ...(canManage
    ? [
        {
          title: t('subscriptions_actions'),
          dataIndex: 'actions',
          key: 'actions',
          render: (_: unknown, record: ISubscription) => {
            const handleDelete = () => onDelete(record);

            return (
              <Button type="text" onClick={handleDelete} size="middle">
                <TrashIcon />
              </Button>
            );
          },
        },
      ]
    : []),
];
